// src/utils/ids/generate-install-id/generate-install-id.ts
function generateInstallId() {
  const data = new Uint8Array(17);
  data[0] = 112;
  self.crypto.getRandomValues(data.subarray(1));
  return btoa(String.fromCharCode.apply(null, Array.from(data))).slice(0, 22).replaceAll(/[\/\+]/g, (character) => character === "/" ? "_" : "-");
}

export {
  generateInstallId
};
